<template>
  <div class="page-content">
    <!-- ░ BreadCrumb ░ -->
    <nav class="page-breadcrumb" id="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">{{ breadcrumbA }}</li>
        <li class="breadcrumb-item active" aria-current="page">
          {{ breadcrumbB }}
        </li>
      </ol>
    </nav>

    <!-- ░ Descripción + leyenda ░ -->
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card"><div class="card-body">
          <h6 class="card-title">
            Gastos cargados por los zonales de los gastos de su personal a cargo
          </h6>
          <p class="card-description mb-0">
            <span class="badge badge-warning  mx-1">En espera</span>
            <span class="badge badge-success  mx-1">Aprobado</span>
            <span class="badge badge-danger   mx-1">Rechazado</span>
            <span class="badge badge-info     mx-1">Pago recibido</span>
            <span class="badge badge-secondary mx-1">Pago pendiente</span>
          </p>
          <hr>
        </div></div>
      </div>
    </div>

    <!-- ░ Spinner / listado ░ -->
    <lista-carga v-if="load"/>
    <div class="row" v-else>
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card"><div class="card-body">

          <!-- filtros de fecha -->
          <div class="row mb-3">
            <div class="col">
              <label>Desde</label>
              <input id="desde" type="date" class="form-control"/>
            </div>
            <div class="col">
              <label>Hasta</label>
              <input id="hasta" type="date" class="form-control"/>
            </div>
            <div class="col">
              <label class="w-100">&nbsp;</label>
              <button id="buscar" class="btn btn-success w-100">Consultar Gastos</button>
            </div>
          </div>

          <!-- tabla -->
          <div class="table-responsive">
            <table id="novedades_hrbp"
                   class="table table-theme table-row v-middle"
                   data-plugin="dataTable">
              <thead>
                <tr>
                  <th><span class="text-muted">ID</span></th>
                  <th><span class="text-muted">Legajo</span></th>
                  <th><span class="text-muted">Status</span></th>
                  <th><span class="text-muted">Nombre</span></th>
                 
                  <th><span class="text-muted">Detalle</span></th>
                  <th><span class="text-muted">Gasto</span></th>
                  <th><span class="text-muted">Fecha</span></th>
                  <th><span class="text-muted">Días</span></th>
                  <th><span class="text-muted">Categoría</span></th>
                  <th><span class="text-muted">Responsable</span></th>
                  <th><span class="text-muted">Comprobante</span></th>
                  <th><span class="text-muted">Nº OP</span></th><!-- ← nueva -->
                  <th><span class="text-muted">Estado&nbsp;Pago</span></th>
                  <th><span class="text-muted">Acción</span></th>
                  <th><span class="text-muted">Auditoría</span></th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="caso in novedades" :key="caso.fireId">
                  <!-- id / legajo -->
                  <td :id="'key'+caso.fireId">{{ caso.id }}</td>
                  <td>{{ caso.legajo }}</td>

                  <!-- status -->
                  <td>
                    <span v-if="caso.status==='En espera'"  class="badge text-uppercase badge-warning">{{ caso.statusMensaje }}</span>
                    <span v-else-if="caso.status==='Aprobado'" class="badge text-uppercase badge-success">{{ caso.statusMensaje }}</span>
                    <span v-else                                 class="badge text-uppercase badge-danger">{{  caso.statusMensaje }}</span>
                  </td>

                  <!-- nombre + Nº OP -->
                  <td class="text-sm text-wrap">{{ caso.nombre }}</td>
                 

                  <!-- detalle / gasto / fecha / días -->
                  <td class="text-sm text-wrap">{{ caso.detalle }}</td>
                  <td class="text-sm text-wrap">{{ caso.gastos }}</td>
                  <td class="text-sm text-wrap">{{ caso.desde }}</td>
                  <td class="text-sm text-wrap">{{ caso.dias }}</td>

                  <!-- categoría / responsable -->
                  <td class="text-sm text-wrap">{{ caso.categoria }}</td>
                  <td class="text-sm text-wrap">{{ caso.responsable }}</td>

                  <!-- comprobante -->
                  <td class="text-sm">
                    <button v-if="caso.certificado!=='-'" class="btn btn-warning btn-sm" @click="openWindow(caso.certificado)">Ver</button>
                    <span v-else>-</span>
                  </td>
                  <td class="text-sm text-wrap">{{ caso.numero_op }}</td>
                  <!-- estado pago -->
                  <td class="text-sm">
                    <span v-if="caso.pagoRecibido"
                          class="badge text-uppercase badge-info"
                          style="cursor:pointer"
                          @click="abrir_firma(caso.pago_link)">
                      Pago recibido
                    </span>
                    <span v-else class="badge text-uppercase badge-secondary">Pago pendiente</span>
                  </td>

                  <!-- select status -->
                  <td>
                    <select class="custom-select resolucionSelect"
                            :disabled="!isEditor('Novedades')"
                            @change="cambiarStatus($event,caso)">
                      <option value="">—</option>
                      <option value="En espera"  :selected="caso.status==='En espera'">En espera</option>
                      <option value="Aprobado"   :selected="caso.status==='Aprobado'">Aprobado</option>
                      <option value="Rechazado"  :selected="caso.status==='Rechazado'">Rechazado</option>
                    </select>
                  </td>

                  <!-- select acción -->
                  <td>
                    <select class="custom-select resolucionSelect"
                            :disabled="!isEditor('Novedades')"
                            @change="cambiarStatus($event,caso)">
                      <option value="">Selecciona Acción</option>
                      <option value="Editar">Editar datos</option>
                    </select>
                  </td>
                </tr>
              </tbody>
            </table>
          </div><!-- /.table-responsive -->
        </div></div>
      </div>
    </div>

    <!-- ░ Modal auditoría (igual que antes) ░ -->
    <!--  …  -->
  </div>
</template>

<script>
/* ───────── Imports ───────── */
import axios from 'axios';
import $ from 'jquery';
import Swal from 'sweetalert2';
require('datatables.net');
require('datatables.net-buttons/js/buttons.colVis.js')();
require('datatables.net-buttons/js/buttons.html5.js')();
require('datatables.net-buttons/js/buttons.flash.js')();
require('datatables.net-buttons/js/buttons.print.js')();
require('../../../public/assets/css/data-table-estilos-propios.css');

import firebase from 'firebase/app';
import 'firebase/database';
import ListaCarga from '../ListaCarga';
import moment from 'moment';

/* ───────── Constantes de sesión ───────── */
const userData       = JSON.parse(sessionStorage.getItem('userData'));
const personalData   = JSON.parse(sessionStorage.getItem('personal'));
const userPermission = JSON.parse(sessionStorage.getItem('userPermisos'));

export default {
  name: 'novedades',
  components: { ListaCarga },
  data () {
    return {
      breadcrumbA : 'Inicio',
      breadcrumbB : 'Novedades de Gastos a pagar',
      descripcion : 'Listado de novedades de gastos a pagar en el personal',
      novedades   : [],
      load        : true,
      opPorFireId : {}      // <─ mapa fireId → OP
    };
  },

  /* ───────── methods ───────── */
  methods: {
    /* util ventana */
    openWindow(l){ window.open(l,'_blank'); },
    abrir_firma(l){ window.open(l,'_blank'); },

    /* permisos */
    isEditor(mod){ const r=userPermission.find(x=>x.ModulosAccess===mod); return r?r.Editor:false; },

    /* 1. Descargar caja_chica y armar mapa */
    async cargarMapaOP(){
      const res = await axios.get('https://aplicativos.firebaseio.com/caja_chica.json');
      Object.values(res.data||{}).forEach(mov=>{
        if(Array.isArray(mov.gastos)){
          mov.gastos.forEach(g=>{
            if(g.fireId) this.opPorFireId[g.fireId]=mov.operacion||'-';
          });
        }
      });
    },

    /* 2. Verificar pago recibido */
    checkPaymentStatus(legajo,id,status){
      if(status!=='Aprobado') return Promise.resolve(false);
      return firebase.database().ref(`pago_recibido/${legajo}/${id}`).once('value')
        .then(s=>!!(s.val()&&s.val().recibido))
        .catch(()=>false);
    },

    /* 3. Cargar novedades */
    async getNovedad(){
      await this.cargarMapaOP();             // primero traemos OP
      const hash=s=>{let h=0;for(let c of s)h=((h<<5)-h)+c.charCodeAt(0)|0;return h;};
      const to4=s=>('0000'+Math.abs(hash(s))).slice(-5);
      const nombrePorLeg=num=>{
        const p=Object.values(personalData).find(p=>p.leg_numero==num);
        return p?`${p.leg_apellido.trim()} ${p.leg_nombre.trim()}`:null;
      };

      const {data}=await axios.get('https://aplicativos.firebaseio.com/novedades_usuarios_test_hrbp.json?orderBy=%22bejerman_id%22&equalTo=%22B1982%22&limitToLast=5000&print=pretty');

      const prom=[];
      $.each(data,(id,caso)=>{
        if(!caso||caso.novedad==='Sin novedad') return;
        prom.push(
          this.checkPaymentStatus(caso.legajo,id,caso.status).then(pago=>{
            const dias=(new Date(caso.hasta)-new Date(caso.desde))/(864e5)+1;
            this.novedades.push({
              fireId:id,
              id:Number(to4(id)),
              legajo:caso.legajo,
              status:caso.status,
              statusMensaje:caso.status,
              nombre:nombrePorLeg(caso.legajo),
              numero_op:this.opPorFireId[id]||'-',        // <- OP real
              detalle:caso.detalle,
              gastos:`$${caso.gastos}`,
              desde:caso.desde,
              hasta:caso.hasta,
               novedad: caso.novedad,
              dias,
              bejerman_id:caso.bejerman_id,
              id_novedad: caso.bejerman_id,
              operacion_raiz:caso.operacion_raiz,
              fecha_novedad:caso.fecha_novedad,
              categoria:localStorage.getItem('cat-'+localStorage.getItem(caso.legajo)),
              responsable_dni:caso.responsable_dni,
              responsable:caso.responsable,
              certificado:caso.certificado||'-',
              pagoRecibido:pago,
              pago_link:`https://servicio.foodservice.com.ar/core/signa/firmados_gastos/recibo_${caso.legajo}_${id}.pdf`
            });
          })
        );
      });
      await Promise.all(prom);
      this.load=false;
      this.$nextTick(()=>this.initDataTable());
    },

    /* 4. DataTable */
    initDataTable(){
      $('#novedades_hrbp').dataTable({
        language:{decimal:',',thousands:'.',info:'Mostrando _START_-_END_ de _TOTAL_',infoEmpty:'0-0 de 0',infoFiltered:'(filtrado de _MAX_)',loadingRecords:'Cargando…',lengthMenu:'Mostrar _MENU_',paginate:{first:'Primero',last:'Último',next:'Siguiente',previous:'Anterior'},processing:'Procesando…',search:'Buscar:',zeroRecords:'No hay resultados',emptyTable:'Sin datos',aria:{sortAscending:'Orden asc',sortDescending:'Orden desc'}},
        scrollX:false,
        dom:'Bfrtip',
        buttons:[
          'copy','excel','csv',
          {extend:'print',text:'Imprimir',className:'imprimir',filename:'Gastos',title:'Gastos',exportOptions:{columns:[1,2,3,4,5,7,8,12]}},
          {text:'En espera',className:'btn btn-warning',action:()=>$('#novedades_hrbp').DataTable().columns(2).search('En espera').draw()},
          {text:'Rechazado',className:'btn btn-warning',action:()=>$('#novedades_hrbp').DataTable().columns(2).search('Rechazado').draw()},
          {text:'Aprobado', className:'btn btn-warning',action:()=>$('#novedades_hrbp').DataTable().columns(2).search('Aprobado').draw()},
          {text:'Pago recibido',className:'btn btn-info',action:()=>$('#novedades_hrbp').DataTable().columns(12).search('Pago recibido').draw()},
          {text:'Pago pendiente',className:'btn btn-secondary',action:()=>$('#novedades_hrbp').DataTable().columns(12).search('Pago pendiente').draw()},
          {text:'Todos',className:'btn btn-warning',action:()=>{const t=$('#novedades_hrbp').DataTable();t.columns(2).search('').columns(12).search('').draw();}}
        ]
      });

      /* filtro rango fecha */
      const rango=(d,h)=>{const arr=[];let c=moment(d);while(c.isSameOrBefore(h)){arr.push(c.format('YYYY-MM-DD'));c=c.add(1,'days');}return arr;};
      $('#buscar').click(()=>{
        const f=rango(moment($('#desde').val()),moment($('#hasta').val())).join('|');
        $('#novedades_hrbp').DataTable().columns(7).search(f,true,false).draw();
      });
    },

    /* 5. Cambiar status (lógica existente) */
     cambiarStatus(event, caso){

     

            if (event.target.value=="Observado"||event.target.value=="Rechazado"||event.target.value=="En espera") {

            //window.$('.modal').modal();
            localStorage.setItem("status_id",caso.fireId);
            localStorage.setItem("status_sms",event.target.value);

            

             firebase.database().ref('novedades_usuarios_test_hrbp/' + caso.fireId).update({
                          status: event.target.value,

                      })
                      .then(()=>{
                          caso.status = event.target.value;
                          caso.statusMensaje = event.target.value;
                      })
                      .catch(e => {
                          console.log(e);
                      });



                      firebase.database().ref('gastos_aprobados/' + caso.responsable_dni+'/'+caso.fireId).update({
                          status: event.target.value,

                      })
                      .then(()=>{
                         
                      })
                      .catch(e => {
                          console.log(e);
                      });
            

            $("#historial").empty();
            }else if (event.target.value == "Editar") {
                window.$('.editar_modal').modal();
                localStorage.setItem("status_id", caso.fireId);
                localStorage.setItem("status_sms", event.target.value);


            } else if (event.target.value == "") {


            }else{
         
                      firebase.database().ref('novedades_usuarios_test_hrbp/' + caso.fireId).update({
                          status: event.target.value,

                      })
                      .then(()=>{
                          caso.status = event.target.value;
                          caso.statusMensaje = event.target.value;
                      })
                      .catch(e => {
                          console.log(e);
                      });

        const addZero =(i) => {
            if (i < 10) {
                i = "0" + i;
            }
            return i;
        }

        var h = new Date();
                var hora = addZero(h.getHours());
                var minutos = ("0" + h.getMinutes()).substr(-2);
                var segundos = ("0" + h.getSeconds()).substr(-2);
                var horaActual = hora +':'+ minutos +':'+ segundos;


                      firebase.database().ref('gastos_aprobados/'+caso.responsable_dni+'/'+caso.fireId).update({
                                  fecha: caso.desde,
                                  fecha_novedad:caso.fecha_novedad,
                                  responsable: caso.responsable,
                                  operacion_raiz:caso.operacion_raiz,
                                  legajo: caso.legajo,
                                  nombre: caso.nombre,
                                  id_novedad: caso.bejerman_id,
                                  novedad: caso.novedad,
                                  bejerman_id: caso.bejerman_id,
                                  detalle: caso.detalle,
                                  status: event.target.value,
                                  status_hora:horaActual,
                                  gastos:caso.gastos,
                                  desde:caso.desde,
                                  hasta:caso.hasta,
                                  checking:1,
                                  responsable_dni:caso.responsable_dni,
                                  certificado:caso.certificado,
                                  horas:'-'
                                 }, function (error) {

                                  if (error) {
                                    console.log("Ocurrio un error! verifique su conexión a internet!")
                                  } else {
                                    console.log("gastos cargados en novedades rrhh")
                                  }

                                });


            }    
      },

  },

  /* lifecycle */
   async mounted() {
     

            this.getNovedad();

           

          

          
              
              const axiosrequest1 = axios.get('https://aplicativos.firebaseio.com/distribucion.json?orderBy=%22$key%22&equalTo=%22999991%22&print=pretty');

              const axiosrequest2 = axios.get('https://auth.foodservice.com.ar/?type=personal&access_token=1234567');

          await axios.all([axiosrequest1, axiosrequest2]).then(axios.spread((zonales, personal) => { 
          
                  var zonal = [];
                  var personal_data = personal.data;



                  const fecha = (dias) =>{


                      var date_min = new Date();
                      date_min.setDate(date_min.getDate() - dias);
                      var mea_min = date_min.getMonth() + 1;
                      var mesea_min = mea_min < 10 ? "0" + mea_min : mea_min;
                      var diaea_min = date_min.getDate();
                      diaea_min = diaea_min < 10 ? "0" + diaea_min : diaea_min;
                      var fecha_min = date_min.getFullYear() + "-" + mesea_min + "-" + diaea_min;

                      $("#fecha-"+dias).html(fecha_min);

                      return fecha_min;

                  }


                  const result_personal = (legajo) => {

                      var personal = "";
                      $.each(personal_data, function(clave, value) {
                            
                          if (value.leg_numero == legajo) {

                              personal = value.leg_numdoc;
                          }
                      })
                      return personal;
                  }


                   const verificar = (dni,dias) => {
                      
                      axios.get("https://auth.foodservice.com.ar/?type=novedades_check&fecha="+fecha(dias)+"&responsable_dni="+dni+"&access_token=1234567")
                        .then((response) => {
                            
                            if (response.data==null) {
                              $("#dni-"+dni+"-"+dias).removeClass("badge-success")
                              $("#dni-"+dni+"-"+dias).addClass("badge-danger")
                            }
                           


                        });

                 
                     
                        
                  }

                   $.each(zonales.data,function(key,value){
                       $.each(value,function(k,v){
                          
                          zonal.push({"legajo":v.legajo,"nombre":v.nombre,"dni":result_personal(v.legajo)});
                          verificar(result_personal(v.legajo),1)
                          verificar(result_personal(v.legajo),2)
                          verificar(result_personal(v.legajo),3)
                          verificar(result_personal(v.legajo),4)

                      })
                    })
                    


            

                
                this.zonales = zonal;

   })).then(() => {});


  }
};
</script>

<style scoped>
.imprimir{
  color:#212529!important;
  background-color:#fbbc06!important;
  border-color:#fbbc06!important;
}
</style>
